import React, { memo, useMemo } from 'react';
import cn from 'classnames';
import { allUpItemFragment } from '@src/utils/type-utils';
import { ContentBlockFragment } from '@graphqlTypes/sitecore';
import FeatureStar from '@public/images/kol/Star.svg';
import { useTranslation } from 'next-i18next';
import { getRaceNum } from '@src/utils/kolBetpickUtils';
import { AppLink } from '@components/common/AppLink';
import Selection from './selection';

type Props = {
    allUpItem: allUpItemFragment;
    contentBlock?: ContentBlockFragment | null;
};

/** 用于betpick-ALL UP -swipe beline 组件 */
const AllUpManualSwipeItem = ({ allUpItem }: Props) => {
    /** Style logic
 * For Tablet/Desktop : The all-up inner box width in tablet (vertical or horizontal) and desktop
If there are 2 races → display them dynamically to occupy the full width of the screen.
If there are 3 races → fix each race at 300px width.
For Mobile : The outter box should be dynamic is width and the inner box width should be fixed width: 
273 px for QQP
230px for other Bet types
 */

    const {
        bankerRow,
        bankerRowSCR,
        selRow,
        selRowSCR,
        selRow2nd,
        selRow2ndSCR,
        selRow3rd,
        selRow3rdSCR,
        selRow4th,
        selRow4thSCR,
    } = allUpItem;
    // console.log('allUpItem----', allUpItem);
    const { t } = useTranslation('kol');
    const showBanker = useMemo(() => Boolean(bankerRow?.value), [bankerRow?.value]);

    // race title
    const getPath = getRaceNum(allUpItem?.path);
    const url = `/betpick/${getPath?.betline}/${getPath?.race}/`;

    const isFeatured = allUpItem?.isFeatured?.boolValue;
    /** 场次 */
    const raceNo = allUpItem?.parent?.raceNo?.numberValue || 0;

    return (
        <div
            style={{ border: '1px solid #E0E0E0' }}
            className={cn(
                'relative bg-white rounded-[4px] min-h-[236px] w-full h-full overflow-clip flex flex-col p-3'
            )}
        >
            <div className='flex justify-center flex-col pb-2'>
                <div className='leading-[18px] font-bold'>
                    <AppLink href={url}>
                        {raceNo > 0 && raceNo <= 15 && t(`race${raceNo}`)} -{` `}
                        {allUpItem?.betPickType?.targetItem?.betTypeName?.value}
                    </AppLink>
                </div>
            </div>
            <div className='grow pt-1 md:pt-2 leading-[16px]'>
                <div className='flex  items-start align-middle mt-2'>
                    <div className='w-full'>
                        <div className=''>
                            {showBanker && (
                                <div className='flex items-start'>
                                    <div className='bg-[#173E96] text-white text-[8px] text-center px-1  min-w-[40px] rounded-sm mr-1'>
                                        {t('betpick.banker')}
                                    </div>
                                    <div
                                        className={cn({
                                            'w-[calc(100%-40px)]': showBanker,
                                            'w-full': !showBanker,
                                        })}
                                    >
                                        <Selection
                                            value={bankerRow?.value}
                                            scratched={bankerRowSCR?.boolValue}
                                        ></Selection>
                                    </div>
                                </div>
                            )}

                            <div className='flex items-start'>
                                {showBanker && (
                                    <div className='bg-[#173E96] text-white text-[8px] text-center px-1  min-w-[40px] rounded-sm mr-1'>
                                        {t('betpick.selection')}
                                    </div>
                                )}
                                <div
                                    className={cn({
                                        'w-[calc(100%-40px)]': showBanker,
                                        'w-full': !showBanker,
                                    })}
                                >
                                    <Selection
                                        value={selRow?.value}
                                        scratched={selRowSCR?.boolValue}
                                    ></Selection>
                                    <Selection
                                        className={cn({ 'mt-2': !showBanker })}
                                        value={selRow2nd?.value}
                                        scratched={selRow2ndSCR?.boolValue}
                                    ></Selection>
                                    <Selection
                                        className={cn({ 'mt-2': !showBanker })}
                                        value={selRow3rd?.value}
                                        scratched={selRow3rdSCR?.boolValue}
                                    ></Selection>
                                    <Selection
                                        className={cn({ 'mt-2': !showBanker })}
                                        value={selRow4th?.value}
                                        scratched={selRow4thSCR?.boolValue}
                                    ></Selection>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isFeatured && <FeatureStar className='absolute -bottom-1 -right-1'></FeatureStar>}
        </div>
    );
};

export default memo(AllUpManualSwipeItem);
